import { useState } from 'react'
import './network.scss'
import {
  AgxColumn,
  AgxHeader,
  AgxRow,
  AgxSelect,
  useDebouncedState,
} from '@urbanx/agx-ui-components'
import ExportDropdown from './ExportDropdown'

import NetworkTable from './NetworkTable'
import FilterDropdown from './FilterDropdown'
import DateRangeSelector from './DateRangeSelector'
import { PageLayout } from 'layout'
import dayjs from 'dayjs'
import useExecutiveGetNetworkMetrics, {
  NetworkReportType,
} from 'services/functions/rex/reporting/useExecutiveGetNetworkMetrics'
import {
  ContractDateToUse,
  GetMetricsRequestTimePeriod,
} from '@urbanx/agx.rex.client'

const DateOptions = [
  { value: GetMetricsRequestTimePeriod.Month, label: 'Month' },
  { value: GetMetricsRequestTimePeriod.Quarter, label: 'Quarter' },
  { value: GetMetricsRequestTimePeriod.Annual, label: 'Year' },
  { value: GetMetricsRequestTimePeriod.Previous, label: 'Last 12 Months' },
  { value: GetMetricsRequestTimePeriod.Custom, label: 'Custom' },
]

const Network = () => {
  const [networkSelectedTab, setNetworkSelectedTab] = useState(
    NetworkReportType.State
  )
  const [selectedFilter, setSelectedFilter] = useState(
    ContractDateToUse.Unconditional
  )
  const [selectedDateType, setSelectedDateType] =
    useState<GetMetricsRequestTimePeriod>(GetMetricsRequestTimePeriod.Month)

  const [{ startDate, endDate }, setSelectedDate] = useDebouncedState<{
    startDate: string
    endDate: string
  }>(
    {
      startDate: dayjs().format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
    },
    500
  )

  const { data: statistics, isPending } = useExecutiveGetNetworkMetrics(
    networkSelectedTab,
    selectedFilter,
    startDate,
    endDate,
    selectedDateType
  )

  return (
    <PageLayout
      agentName={''}
      primaryPageTitle="Reporting"
      currentPageTitle="Network"
    >
      <div className="network-background">
        <AgxColumn extraClasses="executive-dashboard-content">
          <AgxRow spaceBetween centered extraClasses="metrics-header">
            <AgxRow extraClasses="metrics-header-left">
              <AgxHeader
                size={5}
                extraClasses={`key-metrics-header ${
                  networkSelectedTab === NetworkReportType.State
                    ? 'activeheader'
                    : 'inactiveHeader'
                }`}
                onClick={() => setNetworkSelectedTab(NetworkReportType.State)}
              >
                State
              </AgxHeader>
              <AgxHeader
                size={5}
                extraClasses={`run-rate-header ${
                  networkSelectedTab === NetworkReportType.PartnershipLevel
                    ? 'activeheader'
                    : 'inactiveHeader'
                }`}
                onClick={() =>
                  setNetworkSelectedTab(NetworkReportType.PartnershipLevel)
                }
              >
                Partnership Level
              </AgxHeader>
            </AgxRow>
            <div className="metrics-header-right">
              <FilterDropdown
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
              />
              <AgxSelect
                id="networkDateType"
                options={DateOptions}
                defaultValue={DateOptions[0]}
                onValueChanged={({ value }) => {
                  setSelectedDateType(
                    value as unknown as GetMetricsRequestTimePeriod
                  )
                }}
                noHeader
              />
              {selectedDateType === GetMetricsRequestTimePeriod.Custom && (
                <DateRangeSelector
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(dates) => {
                    setSelectedDate(dates)
                  }}
                />
              )}
              <ExportDropdown
                networkMetrics={networkSelectedTab}
                statistics={statistics?.metrics}
              />
            </div>
          </AgxRow>
          <NetworkTable statistics={statistics} isPending={isPending} />
        </AgxColumn>
      </div>
    </PageLayout>
  )
}

export default Network
